export default __webpack_public_path__ + "static/media/Other.3d19aecf.svg";